import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../KycMessaging.module.scss';

const KycCashierRestricted = ({
  isDesktop,
  closeModal,
  uploadDocuments,
  redirectToApps,
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Cashier Restricted - Verification Needed
      </div>
      <div className={styles.bold}>
        {'Your cashier has been restricted pending additional account verification. To complete verification please provide the following:'}
      </div>
      <ul className={styles.list}>
        <li>Proof of Identity</li>
        <li>Proof of Address</li>
      </ul>
      <div>
        <span>{'An email has been sent to your registered email address, outlining the information we require.'}</span>
        <br />
        <br />
        <span>{'If you have submitted the documents already via email, please do not resubmit your documents and await feedback from the Matchbook Compliance team.'}</span>
        <br />
        <br />
        <span>{'Our customer service team is on hand to help with your account via Live Chat.'}</span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeModal}
      >{"I'll do it later"}</Button>
      {isDesktop ? (
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={uploadDocuments}
          className={styles.primaryButton}
        >Upload Documents</Button>
      ) : (
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={redirectToApps}
          className={styles.primaryButton}
        >Get the App</Button>
      )}
    </div>
  </Fragment>
);

KycCashierRestricted.propTypes = {
  closeModal: PropTypes.func.isRequired,
  uploadDocuments: PropTypes.func.isRequired,
  redirectToApps: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
};

export default KycCashierRestricted;

